import React from "react";
import "../style/whyus.css";
import whyus2x from "../assets/whyus2x.png";
import whyusimage2 from "../assets/whyusimage2.png";
import { NavLink } from "react-router-dom";
import quote from "../assets/quote.png";
import inlove from "../assets/inlovewhite.png";

const WhyUs = () => {
  return (
    <div className="whyus-container">
      <section className="whyus-section1">
        <div className="whyus-section1-div1">
          <p>
            <img src={quote} alt="qiote" loading="lazy" />
            At Serenity Residential Care, we understand that choosing the right
            care home is a deeply personal and important decision. That’s why we
            go the extra mile to ensure that every individual feels safe,
            respected, and genuinely cared for in a place they can proudly call
            home. Here’s what makes us different:
          </p>
        </div>

        <div className="whyus-section1-div2">
          <img src={whyus2x} alt="whyus" loading="lazy" />
        </div>
      </section>
      <section className="whyus-section2">
        <div className="whyus-section2-img">
          <img src={whyusimage2} alt="whyus" loading="lazy" />
        </div>

        <div className="whyus-div1-item1-2">
          <img src={inlove} alt="inlove" loading="lazy" />
          <h4>A True Home Environment</h4>
          <h5>
            Our six-bed home in
            <br /> Birmingham is warm, inclusive,
            <br /> and thoughtfully designed.
            <br /> With spacious communal areas,
            <br /> a dedicated respite room, and a<br /> tranquil garden space,
            we offer
            <br /> a safe and peaceful setting
            <br /> where residents can relax,
            <br />
            socialise, and thrive.
          </h5>
        </div>
      </section>
      <section className="whyus-section3">
        <div className="item">
          <h4>
            A True Home
            <br /> Environment
          </h4>
          <h5>
            Our six-bed home in
            <br /> Birmingham is warm, inclusive,
            <br /> and thoughtfully designed.
            <br /> With spacious communal areas,
            <br /> a dedicated respite room, and a<br /> tranquil garden space,
            we offer
            <br /> a safe and peaceful setting
            <br /> where residents can relax,
            <br />
            socialise, and thrive.
          </h5>
        </div>
        <div className="item">
          <h4>
            Well-Led, Friendly
            <br /> Management
          </h4>
          <h5>
            Our six-bed home in
            <br /> Birmingham is warm, inclusive,
            <br /> and thoughtfully designed.
            <br /> With spacious communal areas,
            <br /> a dedicated respite room, and a<br /> tranquil garden space,
            we offer
            <br /> a safe and peaceful setting
            <br /> where residents can relax,
            <br />
            socialise, and thrive.
          </h5>
        </div>
        <div className="item">
          <h4>
            Expertly Trained
            <br /> Staff
          </h4>
          <h5>
            We invest in high-quality training
            <br /> and ongoing development for all
            <br />
            our staff. From management to
            <br /> support workers, every member
            <br /> of our team is equipped with the
            <br /> skills, knowledge, and empathy
            <br /> needed to provide consistent,
            <br /> high-standard care.
          </h5>
        </div>
        <div className="item">
          <h4>
            Warm, Supportive
            <br /> Community
          </h4>
          <h5>
            Serenity is more than just a<br /> care home—it’s a place of
            <br /> connection and belonging.
            <br /> Our residents are part of a close-
            <br />
            knit, respectful community
            <br /> where they are valued and
            <br /> celebrated for who they are.
          </h5>
        </div>
        <div className="item">
          <h4>
            Access to Community
            <br /> Activities
          </h4>
          <h5>
            Through our partnership with
            <br /> the local Wellbeing Centre,
            <br /> residents can take part in a<br /> range of engaging,
            community-
            <br />
            based activities. These
            <br /> experiences encourage
            <br /> independence, build
            <br /> confidence, and promote social
            <br /> inclusion.
          </h5>
        </div>
        <div className="item">
          <h4>
            Committed to
            <br /> Quality
          </h4>
          <h5>
            From our care standards to our
            <br /> facilities, we hold ourselves to
            <br /> the highest levels of
            <br /> professionalism, compassion,
            <br /> and accountability—ensuring
            <br /> peace of mind for residents and
            <br />
            their families alike.
          </h5>
        </div>
      </section>

      <section className="whyus-section5">
        <div className="whyus-section4-div1">
          <h1>Want to Learn More About Our Approach?</h1>
          <h3>
            We'd be happy to discuss how our person-centered approach can
            support
            <br /> you or your loved one. Contact us today for a friendly,
            no-obligation
            <br /> conversation.
          </h3>

          <div className="whyus-section4-div1-navs">
            <NavLink to="/meet-our-team">Meet Our Team</NavLink>
            <NavLink to="/about-us">Schedule a Visit</NavLink>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyUs;
